const STATUS = {
  STOCK: 1,
  SHIP: 2,
  ARRIVAL: 3,
  CANCEL: 99
}

const STATUS_HISTORY_LABEL = {
  STOCK: 'ship.ship_not-ship',
  SHIP: 'ship.ship_already-ship',
  ARRIVAL: 'storage.storage_arrived',
  CANCEL: 'order.order_invalid'
}

const STATUS_SELECTBOX = {
  NOT_COMPLETE: 1,
  STOCK: 2,
  SHIP: 3,
  ARRIVAL: 4,
  CANCEL: 5
}

const STATUS_HISTORY_LABEL_SELECTBOX = {
  NOT_COMPLETE: 'order.order_unfinished',
  STOCK: 'ship.ship_not-ship',
  SHIP: 'ship.ship_already-ship',
  ARRIVAL: 'storage.storage_arrived',
  CANCEL: 'order.order_invalid'
}

export default {
  STATUS,
  STATUS_HISTORY_LABEL,
  STATUS_SELECTBOX,
  STATUS_HISTORY_LABEL_SELECTBOX
}
